import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
    getAccessKey,
    createOrUpdateAccessKey,
    deleteAccessKey,
} from "../../../utils/Vanlifer/community";
import { mapErrorMessages } from "../../../utils/errorHandling";

interface AccessKeyState {
    accessKey?: string | null;
    loading: boolean;
    error?: string;
}

const initialState: AccessKeyState = {
    accessKey: undefined,
    loading: false,
};

export const fetchAccessKey = createAsyncThunk(
    "accessKey/fetchAccessKey",
    async (tourId: number) => {
        return await getAccessKey(tourId);
    }
);

export const upsertAccessKey = createAsyncThunk(
    "accessKey/upsertAccessKey",
    async (tourId: number) => {
        return await createOrUpdateAccessKey(tourId);
    }
);

export const removeAccessKey = createAsyncThunk(
    "accessKey/removeAccessKey",
    async (tourId: number) => {
        await deleteAccessKey(tourId);
        return;
    }
);

export const accessKeySlice = createSlice({
    name: "accessKey",
    initialState,
    reducers: {
        resetAccessKey: (state) => {
            state.accessKey = undefined;
            state.error = undefined;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAccessKey.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchAccessKey.fulfilled, (state, action) => {
                state.accessKey = action.payload;
                state.loading = false;
            })
            .addCase(fetchAccessKey.rejected, (state, action) => {
                state.loading = false;
                state.error = mapErrorMessages({ errorMessage: action.error.message || "" });
            })

            .addCase(upsertAccessKey.pending, (state) => {
                state.loading = true;
            })
            .addCase(upsertAccessKey.fulfilled, (state, action) => {
                state.accessKey = action.payload;
                state.loading = false;
            })
            .addCase(upsertAccessKey.rejected, (state, action) => {
                state.loading = false;
                state.error = mapErrorMessages({ errorMessage: action.error.message || "" });
            })

            .addCase(removeAccessKey.pending, (state) => {
                state.loading = true;
            })
            .addCase(removeAccessKey.fulfilled, (state) => {
                state.accessKey = null;
                state.loading = false;
            })
            .addCase(removeAccessKey.rejected, (state, action) => {
                state.loading = false;
                state.error = mapErrorMessages({ errorMessage: action.error.message || "" });
            });
    },
});

export const { resetAccessKey } = accessKeySlice.actions;
export const accessKeyReducer = accessKeySlice.reducer;
